<template>
  <div>
    <Breadcrumbs primary="Системные отчеты" secondary="Авторизации"/>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card no-top-body-padding no-border">
          <AuthorizationsReport
            get-report-url="/reports/authReport"
            download-report-url="/reports/downloadAuthReport"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AuthorizationsReport from "@shared/components/reports/authorizations/authorizations.component"

export default {
  name: "Authorizations",
  title: "Авторизации",
  components: {AuthorizationsReport}
}

</script>